import { Component, OnInit } from '@angular/core';
import { Resource_Document, Resource, ActionNames } from '../../model/resource-actions';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import { FilterDataService } from '../../services/filter-data.service';
import { AppService } from '../../services/app.service';
import { DataService } from 'projects/Shared-Lib/services/data.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-resource-actions-edit',
  templateUrl: './resource-actions-edit.component.html',
  styleUrls: ['./resource-actions-edit.component.css']
})
export class ResourceActionsEditComponent implements OnInit {
  Doc: Resource_Document;
  selectedEnabled: any;
  //NEW or edit
  DocMode: string = 'NEW';
  Title: string = 'Create';
  ControllerName: string = 'ResourceActions';
  selectedResourceID = '';
  newAction: any = {};

  constructor(private dataSer: DataService, private appService: AppService, private route: ActivatedRoute,
    private DlgService: DialogService, private filterService: FilterDataService,
    private router: Router, private dataService: DataService) {
    this.Doc = new Resource_Document(DlgService, router, dataService);
    this.Doc.ResourceName = '';
    this.Doc.SelectEnabled = 1;
    this.Doc.ActionNameList = [];
  }


  OnDataSrvEnd() {
    setTimeout(() => this.appService.SetLoadingState(false), 0);
  }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      //edit mode
      this.Doc.GetDocument(id);
      this.DocMode = "EDIT";
      this.Title = "Edit";
    }
    else {
      //create mode
      this.Title = "Create";
    }

  }

  isValid(): boolean {
    const result = this.Doc.ResourceName && this.Doc.ResourceName !== '';
    return !result;
  }

  Submit() {
    if (this.DocMode === "NEW") {
      let postData: Resource = {
        ResourceID: this.Doc.ResourceID,
        ResourceName: this.Doc.ResourceName,
        IsEnabled: this.Doc.SelectEnabled === 1,
        ActionNameList: this.Doc.ActionNameList
      };

      this.dataService.addData(this.ControllerName, postData, (ret) => {
        let result = this.DlgService.CreateSubmit();
        result.then((ret) => {
          if (ret === 'Back') {
            this.Cancel();
          }
          else if (ret === 'Create Another') {
            this.Doc.ResourceName = '';
            this.Doc.SelectEnabled = 1;
            this.Doc.ActionNameList = [];
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
    else if (this.Doc.ResourceID && this.DocMode === "EDIT") {
      let postData: Resource = {
        ResourceID: this.Doc.ResourceID,
        ResourceName: this.Doc.ResourceName,
        IsEnabled: this.Doc.SelectEnabled === 1,
        ActionNameList: this.Doc.ActionNameList
      };
      this.dataService.updateData(`${this.ControllerName}`, postData,
        (data) => {
          let result = this.DlgService.EditSubmit();
          result.then((ret) => {
            if (ret === 'Back') {
              this.Cancel();
            }
          }).catch((error) => {
            console.error(error);
          });
        },
        (data) => {
          let result = this.DlgService.ErrorInformation(data.Message);
          result.then((ret) => {
          }).catch((error) => {
            console.error(error);
          });
        }
      );
    }
  }

  Cancel() {
    let lastPageInfo = this.filterService.GetSearchInfo();
    console.log(lastPageInfo);
    if (lastPageInfo.RouteName) {
      this.router.navigate([lastPageInfo.RouteName]);
    }
    else
      this.router.navigate(['/Home/ResourceActions']);
  }

  AddAction() {
    this.Doc.ActionNameList.push(this.newAction);
    this.newAction = {};
  }

  DeleteAction(index) {
    this.Doc.ActionNameList.splice(index, 1);
  }

}

